import {all, call, put, takeEvery, takeLatest} from 'redux-saga/effects'
import moment from 'moment';

import {
    GET_PARTIAL_QUENCHING_DATA_REQUESTED,
    CONTRACT_PARTIAL_QUENCHING_REQUESTED,
    ADD_CLIENTCONTRACTS_REQUESTED,
    GET_CLIENTCONTRACT_REQUESTED,
    GET_PROLONGCALCULATE_REQUESTED,
    ADD_PROLONGCALCULATE_REQUESTED,
    CHANGE_CLIENTCONTRACT_REQUESTED,
    GET_OPERATIONSCONTRACT_REQUESTED,
    CHANGE_CONTRACTSTATUSES_REQUESTED,
    GET_TRANSACTIONS_REQUESTED,
    CHANGE_POSITIONSCONTRACT_REQUESTED,
    TRANSFER_DEALS_REQUESTED,
    GET_INVENTORIES_REQUESTED,
    GET_INVENTORYDEALS_REQUESTED,
    GET_DEALSFORTRANSFER_REQUESTED,
    TRANSFER_SALED_REQUESTED,
    OVERESTIMATION_DEALS_REQUESTED,
    CANCEL_OPERATION_REQUESTED,
    GET_PRINTEDFORM_REQUEST,
    CANCEL_CONTRACT_REQUEST,
    TRANSFER_TO_RETENTION_REQUESTED,
    GET_CLIENTCONTRACTS_REQUESTED,
    LOAD_PRA_FILE,
    GET_ACCEPTANCE_CERTIFICATE,
    CHANGE_CONTRACTSTATUSES_REFUND_REQUESTED,
    CHANGE_CONTRACTSTATUSES_CLOSE_REQUESTED,
    GET_CLIENTSCOUNT_RERQUEST,
    GET_PAYMENTS_ANNUITY_REQUESTED,
    PAY_ANNUITY_PERIOD_REQUESTED,
    GET_CALC_ANNUITY_CLOSE_DEAL_REQUESTED,
    CLOSE_ANNUITY_DEAL_REQUESTED, GET_PRINTED_FORM_AUTO_LOMBARD_REQUEST,
} from '../actions/actionTypes'
import {
    getPartialQuenchingDataFailed,
    getPartialQuenchingDataSuccess,
    contractPartialQuenchingFailed,
    contractPartialQuenchingSuccess,
    addContractFailed,
    getClientContractSuccess,
    getClientContractFailed,
    getProlongCalculateSuccess,
    getProlongCalculateFailed,
    addProlongCalculateSuccess,
    addProlongCalculateFailed,
    changeClientContractSuccess,
    changeClientContractFailed,
    getOperationsSuccess,
    getOperationsFailed,
    changeContractStatusesSuccess,
    changeContractStatusesFailed,
    getTransactionsSuccess,
    getTransactionsFailed,
    changePositionsContractSuccess,
    changePositionsContractFailed,
    transferDealsSuccess,
    transferDealsFailed,
    getInventoriesSuccess,
    getInventoriesFailed,
    getInventoryDealsSuccess,
    getInventoryDealsFailed,
    getDealsForTransferSuccess,
    getDealsForTransferFailed,
    transferSaledSuccess,
    transferSaledFailed,
    overestimationDealsSuccess,
    overestimationDealsFailed,
    cancelOperationSuccess,
    cancelOperationFailed,
    getPrintedFormSuccess,
    getPrintedFormFailed,
    cancelContractSuccess,
    cancelContractFailed,
    getClientContract,
    getDealToRetentionSuccess,
    getWebFormSuccess,
    getDealToRetentionFailed,
    getClientContractsSuccess,
    getClientContractsFailed,
    addContractSuccess,
    overestimationRequestSuccess,
    loadPraSuccess,
    loadPraFailed,
    getClientsCountSuccess,
    getClientsCountFailed,
    getPaymentsAnnuitySuccess,
    getPaymentsAnnuityFailed,
    payAnnuityPeriodSuccess,
    payAnnuityPeriodFailed,
    getCalcAnnuityCloseDealSuccess,
    getCalcAnnuityCloseDealFailed,
    closeDealAnnuitySuccess,
    closeDealAnnuityFailed,
} from '../actions/contractAction'
import {messages} from '../../helpers/messages'
import {dealService} from '../../services/deals-service'
import {transactionsService} from '../../services/transactions-service'
import {reportService} from '../../services/report-service'
import {contractStatuses, viewReports} from '../../helpers/data-constants'
import {generatePrintedForm} from '../../helpers/common'
import {clientShortInfoSaga} from '../actions/clientShortInfoAction';
import {cashBoxService} from "../../services/cashbox-service";

const getAcceptanceCertificate = async (payload) =>
    await reportService.getAcceptanceCertificate(payload)
        .then(({ data }) => data)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages[0]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })

const loadPraFile = async (payload) =>
    await reportService.loadAcceptanceCertificate(payload)
        .then(({ data }) => data)
        .catch(error => {
          if (error.response) {
            let errorData = error.response.data
            let commonError = messages[0]
            if (errorData.errorCode) {
              commonError = messages[errorData.errorCode]
            }
            window.scrollTo(0, 0)
            throw commonError
          }
        })

const payAnnuityPeriod = async (payload) =>
    await transactionsService.payAnnuityPeriod(payload)
        .then(({ data }) => data)
        .catch(error => {
          if (error.response) {
            let errorData = error.response.data
            let commonError = messages[0]
            if (errorData.errorDetails) {
              commonError = messages[errorData.errorDetails]
            }
            window.scrollTo(0, 0)
            throw commonError
          }
        })

const closeAnnuityDeal = async (payload) =>
    await transactionsService.closeAnnuityDeal(payload)
        .then(({ data }) => data)
        .catch(error => {
          if (error.response) {
            let errorData = error.response.data
            let commonError = messages[0]
            if (errorData.errorDetails) {
              commonError = messages[errorData.errorDetails]
            }
            window.scrollTo(0, 0)
            throw commonError
          }
        })

const NextContractNumber = async (payload) =>
    await dealService.getNextContractNumber(payload)
        .then(({ data }) => data)
        .catch(error => {
          if (error.response) {
            let errorData = error.response.data
            let commonError = messages[0]
            if (errorData.errorCode) {
              commonError = messages[errorData.errorCode]
            }
            window.scrollTo(0, 0)
            throw commonError
          }
        })

const couponsAndPrices = async () =>
    await cashBoxService.getPurityGroups()
        .then(({ data }) => data)
        .catch(error => {
          if (error.response) {
            let errorData = error.response.data
            let commonError = messages[0]
            if (errorData.errorCode) {
              commonError = messages[errorData.errorCode]
            }
            window.scrollTo(0, 0)
            throw commonError
          }
        })

const getCashbox = async (id) => {
  return await cashBoxService
      .getCashBox(id)
      .then(({ data }) => data.cashBox)
      .catch(error => {
        if (error.response) {
          let errorData = error.response.data
          let commonError = messages["0"]
          if (errorData.errorCode) {
            commonError = messages[errorData.errorCode]
          }
          window.scrollTo(0, 0)
          throw commonError
        }
      })
}

const contractPartialQuenching = async (payload) =>
    await dealService.contractPartialQuenching(payload)
        .then(({ data }) => data)
        .catch(error => {
          if (error.response) {
            let errorData = error.response.data
            let commonError = messages[0]
            if (errorData.errorCode) {
              commonError = messages[errorData.errorCode]
            }
            window.scrollTo(0, 0)
            throw commonError
          }
        })


const getClientContracts = async payload =>
  await dealService
    .getClientContracts(payload)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const changeClientContract = async (contractId, data) =>
  await dealService
    .changeClientContract(contractId, data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const addContract = async payload => {
  return await dealService.addClientContract(payload)
    .then(({ data }) => data.dealId)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })
}

const getClientContractRequest = async dealId =>
  await dealService.getContract(dealId)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })

const getProlongCalculate = async deals =>
  await dealService.getExtensionDeals({ deals })
    .then(({ data }) => data.extensionDeals)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if(errorData.extensionErrorInfos.length) {
          commonError = errorData.extensionErrorInfos
        } else if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })

const addProlongCalculate = async (deals, deposit) =>
  await dealService.addExtensionDeals({ deals, deposit })
    .then(({ data }) => data.extensionDeals)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })

const getOperations = async dealId =>
  await dealService
    .getOperations(dealId)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const changeContractStatus = async (dealId, newStatus) =>

  await dealService

    .changeContractStatus(dealId, newStatus)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData?.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const changeContractStatusRefund = async (data) =>
  await dealService
    .changeContractStatusRefund(data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData?.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const changeContractStatusClose = async (data) =>
  await  dealService
  .closeContracts(data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData?.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const getTransactions = async data =>
  await transactionsService
    .getTransactions(data)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const getPaymentsPeriodAnnuity = async data =>
  await transactionsService
    .getPeriodsAnnuityDeal(data)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const getAnnuityCalc = async data =>
  await transactionsService
    .getCalcAnnuityDeal(data)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const changePositionsContract = async payload =>
  await dealService.changePositionsContract(payload)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })

const transferDeals = async payload =>
  await dealService.transferDeals(payload)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })

const getInventories = async payload =>
  await dealService
    .getInventories(payload)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const getInventoryDeals = async payload =>
  await dealService
    .getInventoryDeals(payload)
    .then(({ data }) => data)

const getTotalSummInventoryDeals = async payload =>
  await dealService
    .getTotalSummInventoryDeals(payload)
    .then(({ data }) => data)

const getDealsForTransfer = async payload =>
  await dealService
    .getInventoryDeals(payload)
    .then(({ data }) => data.deal)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const transferSaled = async (payload, status) => {
  if (status === contractStatuses.SALED_STORE.param ||
    status === contractStatuses.STORE.param) {
    return await dealService
      .transferSaledStore(payload)
      .then(({ data }) => data)
      .catch(error => {
        if (error.response) {
          let errorData = error.response.data
          let commonError = messages[0]
          if (errorData.errorCode) {
            commonError = messages[errorData.errorCode]
          }
          throw commonError
        }
      })
  }
  else if (status === contractStatuses.GOHRAN_SALE.param ||
    status === contractStatuses.GOHRAN.param) {
    return await dealService
      .transferSaledGoHran(payload)
      .then(({ data }) => data)
      .catch(error => {
        if (error.response) {
          let errorData = error.response.data
          let commonError = messages[0]
          if (errorData.errorCode) {
            commonError = messages[errorData.errorCode]
          }
          throw commonError
        }
      })
  }
  else if ( status === contractStatuses.GARAGE.param ){
    return await dealService
      .transferSaledGarage(payload)
      .then(({ data }) => data)
      .catch(error => {
        if (error.response) {
          let errorData = error.response.data
          let commonError = messages[0]
          if (errorData.errorCode) {
            commonError = messages[errorData.errorCode]
          }
          throw commonError
        }
      })
  }
}

const overestimationDeals = async payload =>
  await dealService
    .overestimationDeals(payload)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const cancelOperation = async (payload) =>
  await dealService
    .cancelOperation(payload)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data;
        let commonError = messages[0];
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode];
        }
        window.scrollTo(0, 0)
        throw commonError;
      }
    });

const generateReport = async (code, data) =>
  await reportService
    .generateReport(code, data)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data;
        let commonError = messages[0];
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode];
        }
        throw commonError;
      }
    })

const generateContentAutoLombard = async (code, data) =>
  await reportService
    .generateContentAutoLombard(code, data)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data;
        let commonError = messages[0];
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode];
        }
        throw commonError;
      }
    })

const getClientsCountReport = async (code, data) =>
  await reportService
    .getClientsCountReport(code, data)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data;
        let commonError = messages[0];
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode];
        }
        throw commonError;
      }
    })

const cancelContract = async (payload) =>
  await dealService.cancelContract(payload)
    .then(({ data }) => data)
    .catch((error) => {
      if (error.response) {
        let errorData = error.response.data;
        let commonError = messages[0];
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError;
      }
    })

const transferToRetention = async (payload) =>
  await dealService.transferContractToRetention(payload)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages[0]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        window.scrollTo(0, 0)
        throw commonError
      }
    })

function* fetchAcceptanceCertificate({payload}) {
    try {
      const report = yield call(() => getAcceptanceCertificate(payload));
        generatePrintedForm(report, payload.filenameCertificate, payload.type);
    } catch (e) {
      yield put(transferDealsFailed(e))
    }
}

function* loadPra({payload}) {
  try {
    const result = yield call(() => loadPraFile(payload));
    yield put(loadPraSuccess(result));
  } catch (e) {
      yield put(loadPraFailed(e))
  }
}

  const generateRefundThingAct = async (userCashBox, dealId) => {
    const { data } = await reportService.getLastReport('REFUND_THING_ACT', userCashBox);
    const lastNumber = data && data.documentNumber ? parseInt(data.documentNumber) + 1 : 1;
    const reportData = {
      dealId: `${dealId}`,
      cashBoxId: userCashBox,
      documentNumber: `${lastNumber}`,
    };
    const report = await generateReport('REFUND_THING_ACT', reportData);
    report !==null && generatePrintedForm(report)
  };

function* fetchPartialQuenchingData({ payload }) {
  try {
    const [contractNumber, purityWithPrices, currentCashbox] = yield all([
      call(NextContractNumber, payload.clientContractCashBoxId),
      call(couponsAndPrices),
      call(getCashbox, payload.activeCashBoxId)
    ])

    let sortedPurityWithPrices = purityWithPrices.purityGroups;
    sortedPurityWithPrices.map(item => item.prices = item.prices.filter(item => item.active))
    sortedPurityWithPrices.map(item => {
      if (item.name === 'Золото') item.prices.map(i => i.name = 'Золото ' + i.name)
      if (item.name === 'Серебро') item.prices.map(i => i.name = 'Серебро ' + i.name)
      return item
    })
    sortedPurityWithPrices = [...sortedPurityWithPrices[0].prices, ...sortedPurityWithPrices[1].prices];
    sortedPurityWithPrices = sortedPurityWithPrices.map(item => {
      return {
        value: item.id,
        label: item.name,
        price: item.price
      }
    })
    let activeCoupons = currentCashbox.coupons.filter(({ active }) => active);
    activeCoupons = currentCashbox.coupons.filter(({ type }) => type.includes('PURITY'));
    if (activeCoupons.length) {
      activeCoupons = activeCoupons.map((c) => ({
        value: c.id,
        label: c.name,
        maxDuration: c.maxDuration,
        minDuration: c.minDuration,
        type: c.type,
        category: c.category
      })).sort((a, b) => a.label.localeCompare(b.label, undefined, {numeric: true,}));
    }
    const partialQuenchingData = {
      nextContractNumber: contractNumber,
      purityWithPrices: sortedPurityWithPrices,
      coupons: activeCoupons,
      operationWithMoney: payload.operationWithMoney
    }
    yield put(getPartialQuenchingDataSuccess(partialQuenchingData))
  } catch (error) {
    yield put(getPartialQuenchingDataFailed(error))
  }
}


function* fetchPartialQuenching({ payload }) {
  try {
    const partialQuenching = yield call(() => contractPartialQuenching(payload))
    yield put(contractPartialQuenchingSuccess(partialQuenching))
  } catch (error) {
    yield put(contractPartialQuenchingFailed(error))
  }
}


function* fetchGetClientContracts({ payload }) {
  try {
    const contracts = yield call(() => getClientContracts(payload))
    yield put(getClientContractsSuccess(contracts))
  } catch (error) {
    yield put(getClientContractsFailed(error))
  }
}

function* fetchAddClientContract({ newContract, clientId }) {
  try {
    const contract = yield call(() => addContract(newContract))
    yield put(addContractSuccess(contract))
    yield put(clientShortInfoSaga(clientId))
  } catch (error) {
    yield put(addContractFailed(error))
  }
}

function* fetchGetClientContract({ contractId }) {
  try {
    const contract = yield call(() => getClientContractRequest(contractId))
    yield put(getClientContractSuccess(contract))
  } catch (error) {
    yield put(getClientContractFailed(error))
  }
}

function* fetchProlongCalculate({ payload }) {
  try {
    const prolongCalculate = yield call(() => getProlongCalculate(payload))
    yield put(getProlongCalculateSuccess(prolongCalculate))
  } catch (error) {
    yield put(getProlongCalculateFailed(error))
  }
}

function* fetchAddProlongCalculate({ payload }) {
  try {
    const prolongCalculate = yield call(() => addProlongCalculate(payload.bodyProlong, payload.bodyDeposit))

    if (prolongCalculate) {
      const { filename, reqBody, viewReport } = payload.bodyReport
      const report = yield all(reqBody.map((i) => call(() => generateReport(viewReport, i))))
      report.forEach((i) => {
        generatePrintedForm(i, filename)
      })
    }

    yield put(addProlongCalculateSuccess(prolongCalculate))
  } catch (error) {
    yield put(addProlongCalculateFailed(error))
  }
}

function* fetchChangeClientContract({ contractId, data, clientId }) {
  try {
    yield call(() => changeClientContract(contractId, data))
    yield put(changeClientContractSuccess())
    yield put(clientShortInfoSaga(clientId))
  } catch (error) {
    yield put(changeClientContractFailed(error))
  }
}

function* fetchGetOperations({ dealId }) {
  try {
    const operations = yield call(() => getOperations(dealId))
    yield put(getOperationsSuccess(operations))
  } catch (error) {
    yield put(getOperationsFailed(error))
  }
}

function* fetchChangeContractStatus({ payload, feature, userCashBox }) {
  try {
    yield call(() => changeContractStatus(payload))
    yield put(changeContractStatusesSuccess())
    if (feature) {
      yield call(() => generateRefundThingAct(userCashBox, payload.dealIds[0]))
    }
  } catch (error) {
    yield put(changeContractStatusesFailed(error))
  }
}

function* fetchChangeContractStatusRefund({ payload, userCashBox }) {
  try {
    const transactionId = yield call(() => changeContractStatusRefund(payload.data))
    yield put(changeContractStatusesSuccess())

    const transaction = yield call(() => generateReport("TRANSACTION_DEBIT", {
      transactionId: transactionId.data.transactionId,
      accepted: payload.data.accepted,
      document: payload.data.passport,
      additionalInfo: payload.data.attachment
    }))
    yield call(() =>generatePrintedForm(transaction))

    yield call(() => generateRefundThingAct(userCashBox, payload.data.dealIds[0]))
  } catch (error) {
    yield put(changeContractStatusesFailed(error))
  }
}

function* fetchChangeContractStatusClose({ payload, transactions }) {
  try {
    const response = yield call(() => changeContractStatusClose(payload.data))
    yield put(changeContractStatusesSuccess())

    for (const transaction of transactions) {
      const reportData = {
        transactionId: response.data.dealRecalculationTrasactionMap[transaction.dealId],
        accepted: transaction.accepted,
        document: transaction.passport,
        description: transaction.description,
        additionalInfo: transaction.attachment,
      };

      const generatedTransaction = yield call(() => generateReport("TRANSACTION_DEBIT", reportData));
      yield call(() => generatePrintedForm(generatedTransaction));
    }

    for (const deal of payload.data.deals) {
      const generatedTransaction = yield call(() => generateReport('CLOSE_DEAL_RECEIPT', { dealId: deal.dealId }));
      yield call(() => generatePrintedForm(generatedTransaction));
    }

  } catch (error) {
    yield put(changeContractStatusesFailed(error))
  }
}

function* fetchGetTransactions({ payload }) {
  try {
    const transactions = yield call(() => getTransactions(payload))
    yield put(getTransactionsSuccess(transactions))
  } catch (error) {
    yield put(getTransactionsFailed(error))
  }
}

function* fetchPaymentsAnnuity({ payload }) {
  try {
    const transactions = yield call(() => getPaymentsPeriodAnnuity(payload))
    yield put(getPaymentsAnnuitySuccess(transactions))
  } catch (error) {
    yield put(getPaymentsAnnuityFailed(error))
  }
}

function* fetchCloseAnnuityDeal({ payload }) {
  try {
    const transactions = yield call(() => closeAnnuityDeal(payload))
    yield put(closeDealAnnuitySuccess(transactions))
  } catch (error) {
    yield put(closeDealAnnuityFailed(error))
  }
}

function* fetchAnnuityCalcClose({ payload }) {
  try {
    const transactions = yield call(() => getAnnuityCalc(payload))
    yield put(getCalcAnnuityCloseDealSuccess(transactions))
  } catch (error) {
    yield put(getCalcAnnuityCloseDealFailed(error))
  }
}

function* fetchPayAnnuityPeriod({ payload }) {
  try {
    const transactions = yield call(() => payAnnuityPeriod(payload))
    yield put(payAnnuityPeriodSuccess(transactions))
  } catch (error) {
    yield put(payAnnuityPeriodFailed(error))
  }
}

function* fetchChangePositionsContract({ payload }) {
  try {
    const contract = yield call(() => changePositionsContract(payload))
    yield put(changePositionsContractSuccess(contract))
  } catch (error) {
    yield put(changePositionsContractFailed(error))
  }
}

function* fetchTransferDeals({ payload, viewReport, filename, name, identity }) {
  try {
    const isInternalMovement = viewReport?.viewInternalReport === viewReports.INTERNAL_MOVEMENT_GOHRAN_PL
    const deals = yield call(() => transferDeals(isInternalMovement ? payload.reqData : payload))
    const transferId = deals.transferId
    if (transferId >= 0) {
      if (
        viewReport && viewReport !== viewReports.INVENTORY_FROM_STORE
        && viewReport !== viewReports.MOVEMENT_STORE
        && viewReport !== viewReports.MOVEMENT_GARAGE
      ) {
        if (isInternalMovement) {
          const report = yield call(() => generateReport(viewReport.viewReport, { transferId }));
          const reportInternalMovement = yield call(() => generateReport(viewReport.viewInternalReport, { ...payload.internalMovementData, transferId }));
          
          generatePrintedForm(report, filename.pdf);
          generatePrintedForm(reportInternalMovement, filename.xlsx, 'xlsx');
        } else {
          const report = viewReport !== viewReports.WITHDRAWAL ?
          yield call(() => generateReport(viewReport, { transferId })) :
          yield call(() => generateReport(viewReport, { transferId, name, identity }))

          generatePrintedForm(report, filename.pdf)
        }      
      } else {
        const report = yield call(() => generateReport(viewReport, { transferId }))
        const reportInvoice = yield call(() => generateReport(viewReports.INVENTORY_INVOICE, { transferId, documentNumber: payload.documentNumber }))
       
        generatePrintedForm(report, filename.pdf)
        generatePrintedForm(reportInvoice, filename.xlsx, 'xlsx')
      }
    }

    yield put(transferDealsSuccess(deals))
  } catch (error) {
    yield put(transferDealsFailed(error))
  }
}

function* fetchGetInventories({ payload }) {
  try {
    const inventories = yield call(() => getInventories(payload))
    yield put(getInventoriesSuccess(inventories))
  } catch (error) {
    yield put(getInventoriesFailed(error))
  }
}

function* fetchGetInventoryDeals({ payload }) {
  try {
    const inventory = yield all([
      call(() => getInventoryDeals(payload)),
      call(() => getTotalSummInventoryDeals(payload.filters))
    ])
    yield put(getInventoryDealsSuccess(inventory))
  } catch (error) {
    let commonError = messages[0]
    if (error.response) {
      let errorData = error.response.data
      if (errorData.errorCode && messages[errorData.errorCode]) {
        commonError = messages[errorData.errorCode]
      }
    }
    yield put(getInventoryDealsFailed(commonError))
  }
}

function* fetchGetDealsForTransfer({ payload }) {
  try {
    const deals = yield call(() => getDealsForTransfer(payload))
    yield put(getDealsForTransferSuccess(deals))
  } catch (error) {
    let commonError = messages[0]
    if (error.response) {
      let errorData = error.response.data
      if (errorData.errorCode && messages[errorData.errorCode]) {
        commonError = messages[errorData.errorCode]
      }
    }
    yield put(getDealsForTransferFailed(commonError))
  }
}

function* fetchTransferSaled({ payload, status, feature, deposit }) {
  const {dealIds, transferIds, cash, cashBoxId, getJsonFile, documentNumber} = payload
  try {
    const dealIdsResult = yield call(() => transferSaled(payload, status, deposit))

    if ( status === contractStatuses.GOHRAN.param && dealIdsResult.transferId ) {
      const { transferId } = dealIdsResult;
      const filename = 'exp_' + transferId + '_' + moment().format('YYYY-MM-DD');

      const report = yield call(() => generateReport(viewReports.MOVEMENT_GOHRAN, { transferId }))
      generatePrintedForm(report, `${filename}.xlsx`, "xlsx")
      if ( getJsonFile ) {
        const reportJson = yield call(() => generateReport(viewReports.MOVEMENT_GOHRAN_JSON, { transferId, documentNumber }))
        generatePrintedForm(reportJson, `${filename}.json`, "json")
      }
    }
    if ( status === contractStatuses.STORE.param && !cash && feature) {
      const filename = 'exp_' + transferIds + '_' + moment().format('YYYY-MM-DD') + '.xlsx';
      const report =  yield call(() => generateReport(viewReports.SALE_INVOICE, { dealIds, transferIds, saleInvoice: true, cashBoxId }))

      generatePrintedForm(report, filename, "xlsx")
    }
    yield put(transferSaledSuccess(dealIdsResult))
  } catch (error) {
    yield put(transferSaledFailed(error))
  }
}

function* fetchGetPrintedForm({ payload }) {
  try {
    const report = yield call(() => generateReport(payload.viewReport, payload.reqBody))

    if(payload.viewReport === 'GROSS_INCOME') {
      report.content !== null ? yield put(getWebFormSuccess(report)) : yield put(getPrintedFormFailed(messages[16700]))
    } else if (report.content === null) {
      yield put(getPrintedFormSuccess('Ошибка! Операция не производилась!' ))
    } else {
      generatePrintedForm(report, payload.filename, payload.type)
      yield put(getPrintedFormSuccess())
    }
  } catch (error) {
    yield put(getPrintedFormFailed(error))
  }
}

function* fetchPrintedFormAutoLombard({ payload }) {
  try {
    const report = yield call(() => generateContentAutoLombard(payload.dealId))

      generatePrintedForm(report, payload.filename, payload.type)
      yield put(getPrintedFormSuccess())
  } catch (error) {
    yield put(getPrintedFormFailed(error))
  }
}

function* fetchGetClientsCount({ payload }) {
  try {
    const report = yield call(() => getClientsCountReport(payload.viewReport, payload.reqBody))
    yield put(getClientsCountSuccess(report))

  } catch (error) {
    yield put(getClientsCountFailed(error))
  }
}

function* fetchOverestimationDeals({ payload }) {
  try {
    const dealIds = yield call(() => overestimationDeals(payload.bodyOverestimation))

    if (dealIds && payload.bodyReport) {
      const { filename, reqBodyReport, viewReport } = payload.bodyReport
      const report = yield call(() => generateReport(viewReport, reqBodyReport))

      generatePrintedForm(report, filename)
    }

    yield put(overestimationDealsSuccess(dealIds))
    yield put(overestimationRequestSuccess(dealIds))
  } catch (error) {
    yield put(overestimationDealsFailed(error))
  }
}

function* fetchCancelOperation({ payload }) {
  try {
    const operation = yield call(() => cancelOperation(payload))
    yield put(cancelOperationSuccess(operation))
  } catch (error) {
    yield put(cancelOperationFailed(error))
  }
}

function* fetchCancelContract({ payload }) {
  try {
    yield call(() => cancelContract(payload));
    yield put(getClientContract(payload.dealId))
    yield put(cancelContractSuccess());
  } catch (error) {
    yield put(cancelContractFailed(error));
  }
}
function* fetchTransferToRetention({ payload }) {
  try {
    const deal = yield call(transferToRetention, payload)
    yield put(getDealToRetentionSuccess(deal))
  } catch (error) {
    yield put(getDealToRetentionFailed(error))
  }
}

function* getAcceptanceCertificateSaga(){
    yield takeEvery(GET_ACCEPTANCE_CERTIFICATE, fetchAcceptanceCertificate)
}

function* loadPraFileSaga() {
  yield takeEvery(LOAD_PRA_FILE, loadPra)
}

function* getPartialQuenchingDataSaga() {
  yield takeEvery(GET_PARTIAL_QUENCHING_DATA_REQUESTED, fetchPartialQuenchingData)
}

function* contractPartialQuenchingSaga() {
  yield takeLatest(CONTRACT_PARTIAL_QUENCHING_REQUESTED, fetchPartialQuenching)
}


function* getClientContractsSaga() {
  yield takeLatest(GET_CLIENTCONTRACTS_REQUESTED, fetchGetClientContracts)
}

function* addClientContractSaga() {
  yield takeEvery(ADD_CLIENTCONTRACTS_REQUESTED, fetchAddClientContract)
}

function* getClientContractSaga() {
  yield takeLatest(GET_CLIENTCONTRACT_REQUESTED, fetchGetClientContract)
}

function* getProlongCalculateSaga() {
  yield takeEvery(GET_PROLONGCALCULATE_REQUESTED, fetchProlongCalculate)
}

function* addProlongCalculateSaga() {
  yield takeEvery(ADD_PROLONGCALCULATE_REQUESTED, fetchAddProlongCalculate)
}

function* changeClientContractSaga() {
  yield takeEvery(CHANGE_CLIENTCONTRACT_REQUESTED, fetchChangeClientContract)
}

function* getOperationsSaga() {
  yield takeEvery(GET_OPERATIONSCONTRACT_REQUESTED, fetchGetOperations)
}

function* changeContractStatusSaga() {
  yield takeEvery(CHANGE_CONTRACTSTATUSES_REQUESTED, fetchChangeContractStatus)
}
function* changeContractStatusRefundSaga() {
  yield takeEvery(CHANGE_CONTRACTSTATUSES_REFUND_REQUESTED, fetchChangeContractStatusRefund)
}

function* changeContractStatusCloseSaga() {
  yield takeEvery(CHANGE_CONTRACTSTATUSES_CLOSE_REQUESTED, fetchChangeContractStatusClose)
}

function* getTransactionsSaga() {
  yield takeEvery(GET_TRANSACTIONS_REQUESTED, fetchGetTransactions)
}

export function* getPaymentsAnnuitySaga() {
  yield takeEvery(GET_PAYMENTS_ANNUITY_REQUESTED, fetchPaymentsAnnuity)
}

export function* closeAnnuityDealSaga() {
  yield takeEvery(CLOSE_ANNUITY_DEAL_REQUESTED, fetchCloseAnnuityDeal)
}

export function* getPaymentPeriodAnnuitySaga() {
  yield takeEvery(GET_CALC_ANNUITY_CLOSE_DEAL_REQUESTED, fetchAnnuityCalcClose)
}

export function* payAnnuityPeriodSaga() {
  yield takeEvery(PAY_ANNUITY_PERIOD_REQUESTED, fetchPayAnnuityPeriod)
}

function* changePositionsContractSaga() {
  yield takeEvery(CHANGE_POSITIONSCONTRACT_REQUESTED, fetchChangePositionsContract)
}

function* transferDealsSaga() {
  yield takeEvery(TRANSFER_DEALS_REQUESTED, fetchTransferDeals)
}

function* getInventoriesSaga() {
  yield takeEvery(GET_INVENTORIES_REQUESTED, fetchGetInventories)
}

function* getInventoryDealsSaga() {
  yield takeEvery(GET_INVENTORYDEALS_REQUESTED, fetchGetInventoryDeals)
}

function* getDealsForTransferSaga() {
  yield takeEvery(GET_DEALSFORTRANSFER_REQUESTED, fetchGetDealsForTransfer)
}

function* transferSaledSaga() {
  yield takeEvery(TRANSFER_SALED_REQUESTED, fetchTransferSaled)
}

function* overestimationDealsSaga() {
  yield takeEvery(OVERESTIMATION_DEALS_REQUESTED, fetchOverestimationDeals)
}

function* cancelOperationSaga() {
  yield takeEvery(CANCEL_OPERATION_REQUESTED, fetchCancelOperation)
}

function* getPrintedFormSaga() {
  yield takeEvery(GET_PRINTEDFORM_REQUEST, fetchGetPrintedForm)
}

function* getPrintedFormAutoLombardSaga() {
  yield takeEvery(GET_PRINTED_FORM_AUTO_LOMBARD_REQUEST, fetchPrintedFormAutoLombard)
}

function* getClientsCountSaga() {
  yield takeEvery(GET_CLIENTSCOUNT_RERQUEST, fetchGetClientsCount)
}

function* cancelContractSaga() {
  yield takeEvery(CANCEL_CONTRACT_REQUEST, fetchCancelContract)
}
function* transferToRetentionSaga() {
  yield takeEvery(TRANSFER_TO_RETENTION_REQUESTED, fetchTransferToRetention)
}

export {
  getClientContractsSaga,
  getPrintedFormAutoLombardSaga,
  addClientContractSaga,
  getClientContractSaga,
  getProlongCalculateSaga,
  addProlongCalculateSaga,
  changeClientContractSaga,
  getOperationsSaga,
  changeContractStatusSaga,
  changeContractStatusRefundSaga,
  changeContractStatusCloseSaga,
  getTransactionsSaga,
  changePositionsContractSaga,
  transferDealsSaga,
  getInventoriesSaga,
  getInventoryDealsSaga,
  getDealsForTransferSaga,
  transferSaledSaga,
  overestimationDealsSaga,
  cancelOperationSaga,
  getPrintedFormSaga,
  getClientsCountSaga,
  cancelContractSaga,
  transferToRetentionSaga,
  getPartialQuenchingDataSaga,
  contractPartialQuenchingSaga,
  loadPraFileSaga,
  getAcceptanceCertificateSaga
}
